module.exports = __webpack_public_path__ + "img/camera-corner-bottom-right.ee1e174d.png";